import { render, staticRenderFns } from "./EmployerAndEmploymentDetails.vue?vue&type=template&id=7b046a2f&scoped=true"
import script from "./EmployerAndEmploymentDetails.vue?vue&type=script&lang=js"
export * from "./EmployerAndEmploymentDetails.vue?vue&type=script&lang=js"
import style0 from "./EmployerAndEmploymentDetails.vue?vue&type=style&index=0&id=7b046a2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b046a2f",
  null
  
)

export default component.exports